export default "__VITE_ASSET__C88hue3G__"